export const HOME_PAGE_CONTENT_PATH = 'home-page-content';
